/** @format */

import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../components/globalLoader";
import { useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";

const routes = [
  {
    path: "/my-courses",
    exact: true,
    Component: lazy(() => import("../pages/home")),
  },

  {
    path: "/auth/login",
    exact: true,
    Component: lazy(() => import("../pages/auth/login")),
  },
  {
    path: "/auth/signup",
    exact: true,
    Component: lazy(() => import("../pages/auth/signup")),
  },
  {
    path: "/auth/forgot-password",
    exact: true,
    Component: lazy(() => import("../pages/auth/forgotPassword")),
  },
  {
    path: "/auth/404",
    exact: true,
    Component: lazy(() => import("../components/pageNotFound")),
  },
  {
    path: "/auth/verify",
    exact: true,
    Component: lazy(() => import("../pages/auth/verify")),
  },
  {
    path: "/course-details/:id",
    exact: true,
    Component: lazy(() => import("../pages/courses/courseDetails")),
  },
  {
    path: "/course-overview/:id",
    exact: true,
    Component: lazy(() => import("../pages/courses/courseOverview")),
  },
  {
    path: "/course-result/:courseId",
    exact: true,
    Component: lazy(() => import("../pages/courses/courseResults")),
  },
  {
    path: "/video-quiz",
    exact: true,
    Component: lazy(() => import("../pages/courses/VideoQuiz")),
  },
  {
    path: "/principal-dashboard",
    exact: true,
    Component: lazy(() => import("../pages/dashboard/principalDashboard")),
  },

  {
    path: "/superadmin-dashboard",
    exact: true,
    Component: lazy(() => import("../pages/dashboard/superadminDashboard")),
  },
  {
    path: "/superadmin-dashboard-revamp",
    exact: true,
    Component: lazy(() =>
      import("../pages/dashboard/superadminDashboardRevamp")
    ),
  },
  {
    path: "/superadmin-dashboard-new-structure",
    exact: true,
    Component: lazy(() =>
      import("../pages/dashboard/superadminDashboardNewStructure")
    ),
  },
  {
    path: "/quiz/:id",
    exact: true,
    Component: lazy(() => import("../pages/quiz")),
  },
  {
    path: "/quiz-explanation/:id",
    exact: true,
    Component: lazy(() => import("../pages/quiz/quizExplanation")),
  },
  {
    path: "/quiz-overview/:id",
    exact: true,
    Component: lazy(() => import("../pages/quiz/quizOverview")),
  },
  {
    path: "/shikshak-skill-list",
    exact: true,
    Component: lazy(() => import("../pages/quiz/quizListing")),
  },
  {
    path: "/dashboard",
    exact: true,
    Component: lazy(() => import("../pages/dashboard")),
  },
  {
    path: "/school-profile",
    exact: true,
    Component: lazy(() => import("../pages/schoolProfile")),
  },
  {
    path: "/users",
    exact: true,
    Component: lazy(() => import("../pages/users")),
  },
  {
    path: "/user/upload",
    exact: true,
    Component: lazy(() => import("../pages/users/bulkUpload")),
  },
  {
    path: "/course-dashboard",
    exact: true,
    Component: lazy(() => import("../pages/dashboard/courseDashboard")),
  },
  {
    path: "/quiz-dashboard",
    exact: true,
    Component: lazy(() => import("../pages/dashboard/quizDashboard")),
  },
  {
    path: "/manage",
    exact: true,
    Component: lazy(() => import("../pages/manage")),
  },
  {
    path: "/observation-form",
    exact: true,
    Component: lazy(() => import("../pages/observation")),
  },
  {
    path: "/teacher-observation-report",
    exact: true,
    Component: lazy(() =>
      import("../pages/observation/teacherObservationReport")
    ),
  },

  {
    path: "/teacher-observation-dashboard",
    exact: true,
    Component: lazy(() =>
      import("../pages/dashboard/teacherObservationDashboard")
    ),
  },
  {
    path: "/teacher-audio-observation",
    exact: true,
    Component: lazy(() => import("../pages/observation/audioObservation")),
  },
  {
    path: "/self-observation",
    exact: true,
    Component: lazy(() => import("../pages/selfObservation")),
  },
  {
    path: "/self-observation/record",
    exact: true,
    Component: lazy(() => import("../pages/selfObservation/Record")),
  },
  {
    path: "/self-observation/report/:id",
    exact: true,
    Component: lazy(() => import("../pages/selfObservation/Report")),
  },
  {
    path: "/self-observation/school",
    exact: true,
    Component: lazy(() => import("../pages/selfObservation/SchoolView")),
  },
  {
    path: "/self-observation/settings",
    exact: true,
    Component: lazy(() => import("../pages/selfObservation/Settings")),
  },
  {
    path: "/utkarsh",
    exact: true,
    Component: lazy(() => import("../pages/utkarsh/ObservationList")),
  },
  {
    path: "/utkarsh/observe",
    exact: true,
    Component: lazy(() => import("../pages/utkarsh/ObservationWizard")),
  },
  {
    path: "/utkarsh/report/:id",
    exact: true,
    Component: lazy(() => import("../pages/utkarsh/ObservationReport")),
  },
  {
    path: "/utkarsh/analytics",
    exact: true,
    Component: lazy(() => import("../pages/utkarsh/Analytics")),
  },
  {
    path: "/question-bank",
    exact: true,
    Component: lazy(() => import("../pages/questionBank")),
  },
  {
    path: "/question-bank/create",
    exact: true,
    Component: lazy(() => import("../pages/questionBank/questionEditor")),
  },
  {
    path: "/question-bank/:id/edit",
    exact: true,
    Component: lazy(() => import("../pages/questionBank/questionEditor")),
  },
  {
    path: "/question-bank/upload",
    exact: true,
    Component: lazy(() => import("../pages/questionBank/bulkUpload")),
  },
  {
    path: "/sections",
    exact: true,
    Component: lazy(() => import("../pages/students/sections")),
  },
  {
    path: "/students",
    exact: true,
    Component: lazy(() => import("../pages/students")),
  },
  {
    path: "/students/upload",
    exact: true,
    Component: lazy(() => import("../pages/students/bulkUpload")),
  },
  {
    path: "/my-tests",
    exact: true,
    Component: lazy(() => import("../pages/tests/availableTests")),
  },
  {
    path: "/test/:testPaperId",
    exact: true,
    Component: lazy(() => import("../pages/tests/takeTest")),
  },
  {
    path: "/test-result/:attemptId",
    exact: true,
    Component: lazy(() => import("../pages/tests/testResults")),
  },
  {
    path: "/my-performance",
    exact: true,
    Component: lazy(() => import("../pages/tests/performanceDashboard")),
  },
  {
    path: "/parent-dashboard",
    exact: true,
    Component: lazy(() => import("../pages/tests/parentDashboard")),
  },
  {
    path: "/cycles",
    exact: true,
    Component: lazy(() => import("../pages/assessmentSetup/cycles")),
  },
  {
    path: "/blueprints",
    exact: true,
    Component: lazy(() => import("../pages/assessmentSetup/blueprints")),
  },
  {
    path: "/test-papers",
    exact: true,
    Component: lazy(() => import("../pages/assessmentSetup/testPapers")),
  },
  {
    path: "/test-papers/create",
    exact: true,
    Component: lazy(() => import("../pages/assessmentSetup/testPaperEditor")),
  },
  {
    path: "/test-papers/:id/edit",
    exact: true,
    Component: lazy(() => import("../pages/assessmentSetup/testPaperEditor")),
  },
  {
    path: "/evaluate-responses",
    exact: true,
    Component: lazy(() => import("../pages/tests/evaluateResponses")),
  },
  {
    path: "/management-dashboard",
    exact: true,
    Component: lazy(() => import("../pages/assessmentSetup/managementDashboard")),
  },
  {
    path: "/performance",
    exact: true,
    Component: lazy(() => import("../pages/performance")),
  },
  {
    path: "/public-test/:token",
    exact: true,
    Component: lazy(() => import("../pages/tests/publicTest")),
  },
];

const RoleBasedRedirect = () => {
  const currentUser = useSelector((state) => state?.userData);
  const userType = currentUser?.school_data?.user_type;

  if (userType === "student") return <Navigate to="/my-tests" replace />;
  if (userType === "parent") return <Navigate to="/parent-dashboard" replace />;
  return <Navigate to="/dashboard" replace />;
};

const GlobalRoutes = () => {
  const globalRouterAnimation = useSelector(
    (state) => state.globalData?.routerAnimation
  );
  return (
    <Routes>
      <Route exact path="/" element={<RoleBasedRedirect />} />
      {routes.map(({ path, Component, exact }) => (
        <Route
          path={path}
          key={path}
          exact={exact}
          element={
            <CSSTransition
              key={path}
              appear
              classNames={globalRouterAnimation}
              timeout={globalRouterAnimation === "none" ? 0 : 300}
            >
              <Suspense fallback={<Loader />}>
                <Component />
              </Suspense>
            </CSSTransition>
          }
        />
      ))}
      <Route exact path="*" element={<Navigate to="/auth/404" replace />} />
    </Routes>
  );
};

export default GlobalRoutes;
